import React from "react";
import { IEventSummary, IShow } from "@eagerdog/interfaces";

import { IBreedBucket, groupLabel } from "./partitionScores";
import { NestedSection } from "./NestedSection";
import LicensedBreedCard from "./LicensedBreedCard";
import NonLicensedBreedCard from "./NonLicensedBreedCard";
import BraceBreedCard from "./BraceBreedCard";

interface IProps {
  breedGroup: string;
  breeds: IBreedBucket[];
  event: IEventSummary;
  show: IShow;
  onSaved: () => void;
  card: "regular" | "altered" | "novice_puppy" | "veteran" | "brace";
}

export const BreedGroupSection: React.FC<IProps> = ({ breedGroup, breeds, event, show, onSaved, card }) => {
  return (
    <NestedSection title={groupLabel(breedGroup)} meta={`${breeds.length} breed${breeds.length === 1 ? "" : "s"}`}>
      {breeds.map((bucket) => {
        if (card === "brace") {
          return (
            <BraceBreedCard
              key={bucket.breed}
              breed={bucket.breed}
              breedGroup={bucket.breedGroup}
              scores={bucket.scores}
              event={event}
              show={show}
              onSaved={onSaved}
            />
          );
        }
        if (card === "novice_puppy" || card === "veteran") {
          return (
            <NonLicensedBreedCard
              key={bucket.breed}
              level={card}
              title={card === "veteran" ? "Veteran" : "Novice Puppy"}
              breed={bucket.breed}
              breedGroup={bucket.breedGroup}
              scores={bucket.scores}
              event={event}
              show={show}
              onSaved={onSaved}
            />
          );
        }
        return (
          <LicensedBreedCard
            key={bucket.breed}
            stream={card}
            breed={bucket.breed}
            breedGroup={bucket.breedGroup}
            scores={bucket.scores}
            event={event}
            show={show}
            onSaved={onSaved}
          />
        );
      })}
    </NestedSection>
  );
};
